import { render, staticRenderFns } from "./cv-pagination.vue?vue&type=template&id=5caea014&"
import script from "./cv-pagination.vue?vue&type=script&lang=js&"
export * from "./cv-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports